import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import type { Translations } from "@/data/translations";
import { translations } from "@/data/translations";

export type Lang = "mk" | "en";

const LangContext = createContext<Lang>("mk");

export function LangProvider({
	lang,
	children,
}: {
	lang: Lang;
	children: ReactNode;
}) {
	return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
}

export function useLang(): Translations {
	const lang = useContext(LangContext);
	return translations[lang];
}

export function useLangKey(): Lang {
	return useContext(LangContext);
}

export function useLangPrefix(): string {
	const lang = useContext(LangContext);
	return lang === "en" ? "/en" : "";
}
